<template>
    <div class="services">
        <scroll-parallax :speed="0.1">
            <BackgroundImage image="services" />
        </scroll-parallax>
        <div class="container">
            <scroll-parallax :speed="0.15">
                <div class="services__header">
                    <h2>Våra <span>tjänster</span></h2>
                    <div class="services__quote">
                        <Quote
                            text="Vi har mer än 70-års sammantagen efarenhet av detailjhandeln där vi funnits med sedan kassasystemen blev PC-baserade och den första korttransaktionen genomfördes"
                        />
                    </div>
                </div>
            </scroll-parallax>
        </div>

        <div class="services__content">
            <div class="container">
                <Animate>
                    <div class="services__content-grid">
                        <div
                            v-for="service in serviceList"
                            :key="service.id"
                            className="services__content-grid-box"
                        >
                            <div class="services__content-grid-offer">
                                <img :src="service.icon" />
                            </div>
                            <div class="services__content-grid-description">
                                <h5 class="services__content-grid-header">
                                    {{ service.heading }}
                                </h5>
                                <p>
                                    {{ service.text }}
                                </p>
                            </div>
                        </div>
                    </div>
                </Animate>
            </div>

            <Animate>
                <div class="services__content-references">
                    <div class="container">
                        <h4>
                            Vi berättar gärna om <span>våra referenser</span>
                        </h4>
                        <div class="services__content-references-info">
                            <p>
                                Genom åren har vi arbetat och arbetar fortsatt
                                tillsammans med flera välkända varumärken inom
                                detaljhandeln i Sverige och Norden. Våra
                                lösningar används idag av tusentals användare
                                varje dag och vi är superstolta över våra
                                relationer.
                            </p>

                            <Button variant="primary" to="contact">
                                <template v-slot:text>
                                    Kontakta oss gärna
                                    <span>för referenser</span>
                                </template>
                                <template v-slot:icon>
                                    <img
                                        src="../assets/icons/landing-btn-contact-icon.svg"
                                    />
                                </template>
                            </Button>
                        </div>
                    </div>
                </div>
            </Animate>

            <Animate>
                <div class="container">
                    <div class="services__content-trailer">
                        <h4>
                            Visst låter det spännande?
                            <span>Vill du veta mer?</span>
                        </h4>
                        <p>
                            Läs mer om vår
                            <router-link to="idea-vision"
                                >idé och vision</router-link
                            >
                            eller kontakta oss direkt för att prata mer om vad
                            vi kan göra för er. Antingen via vårt
                            <router-link to="contact"
                                >kontaktformulär</router-link
                            >
                            eller direkt via e-post på
                            <a href="mailto:info@retailonly.se"
                                >info@retailonly.se</a
                            >
                        </p>
                        <p>
                            Ni kan också titta in och följa våra sidor på
                            <a
                                href="https://www.facebook.com/Retail-Only-465857273847638/"
                                target="_blank"
                                >Facebook</a
                            >
                            och
                            <a
                                href="https://www.linkedin.com/company/retail-only-i-sverige-ab/"
                                target="_blank"
                                >LinkedIn</a
                            >
                            där vi postar nyheter och sådant vi håller på med
                            just nu.
                        </p>
                    </div>
                </div>
            </Animate>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import ScrollParallax from 'vue3-parallax/src/components/ScrollParallax.vue'
import Animate from '@/components/Common/Animate.vue'

import BackgroundImage from '@/components/Common/BackgroundImage.vue'
import Quote from '@/components/Common/Quote.vue'
import Button from '@/components/Common/Button.vue'

export default defineComponent({
    name: 'Services',
    components: {
        ScrollParallax,
        BackgroundImage,
        Quote,
        Button,
        Animate,
    },
    setup() {
        const serviceList = [
            {
                id: 'code',
                icon: require('../assets/icons/services-code-icon.svg'),
                heading: 'Utveckling av mjukvara för detaljhandeln',
                text:
                    'På uppdrag utvecklar vi både back-end och front-end baserat på dina behov inom ramen för vår mångåriga kunnande av detaljhandeln',
            },
            {
                id: 'apps',
                icon: require('../assets/icons/services-apps-icon.svg'),
                heading: 'Egenutvecklade system och applikationer',
                text:
                    'Med all vår erfarenhet från detaljhandeln har vi utvecklat programvaror för olika butikstillämpningar som går snabbt och enkelt att komma igång med',
            },
            {
                id: 'maintenance',
                icon: require('../assets/icons/services-maintenance-icon.svg'),
                heading: 'Applikationsförvaltning',
                text:
                    'Oavsett om det handlar om mjukvara utvecklat specifikt för er eller våra egna produkter kan vi hjälpa till med förvaltning efter applikationen gått live',
            },
            {
                id: 'project',
                icon: require('../assets/icons/services-project-icon.svg'),
                heading: 'Projektledning, testledning och dokumentation',
                text:
                    'Behöver ni hjälp att komma igång med eller få på plats ett nytt system eller en ny applikation. Vi kan hjälpa till med projektledningen, test och dokumentationen',
            },
            {
                id: 'solution',
                icon: require('../assets/icons/services-solution-icon.svg'),
                heading: 'Konsultationstjänster och lösningsbeskrinvningar',
                text:
                    'Med vår mångåriga erfarenhet från detaljhandeln kan vi hjälpa till med t.ex. förstudier eller liknande arbete för att detaljera lösningsförslag och beslutsunderlag',
            },
            {
                id: 'support',
                icon: require('../assets/icons/services-support-icon.svg'),
                heading: 'Third line support',
                text:
                    'Behöver ni experthjälp så kan vi ta uppdrag där vi agerar som så kallad “third line support”. Vi är den sista utposten och hjälper till när frågorna är extra svåra att lösa',
            },
        ]

        return {
            serviceList,
        }
    },
})
</script>

<style lang="scss" scoped>
@import '../styles/variables';
@import '../styles/mixins';
@import '../styles/config';

.services {
    position: relative;

    &__header {
        height: 80vh;
        padding-top: 20vh;
        position: relative;
        z-index: 10;

        @include mQ(700px) {
            text-align: center;
            padding-top: 18vh;
        }
    }

    &__quote {
        z-index: 20;
        width: 100%;
    }

    &__content {
        width: 100%;
        padding: 10rem 0 6rem 0;
        position: relative;
        z-index: 5;

        @include mQ(700px) {
            padding: 6rem 0 4rem 0;
        }

        &-grid {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
            gap: 2rem;

            &-header {
                font-size: 1.3rem;
            }

            &-box {
                display: flex;
                flex-direction: column;
                align-items: center;
                text-align: center;
                border-radius: 10px;
                background-color: #fff;
                border: 1px solid $font-color-main-light-grey;
                box-shadow: 2px 2px 5px 2px rgba(0, 0, 0, 0.05);
            }

            &-offer {
                width: 100%;
                padding: 2rem 0;
                background: linear-gradient(
                    to bottom right,
                    #fff,
                    lighten($accent-color-very-light, 3%)
                );
            }

            &-description {
                padding: 2rem;

                p {
                    color: $font-color-main-grey;
                }
            }
        }

        &-references {
            margin-top: 6rem;
            background: linear-gradient(
                to bottom right,
                #fff,
                lighten($accent-color-very-light, 3%)
            );
            padding: 4rem 0;
            text-align: center;

            @include mQ(750px) {
                margin-top: 4rem;
            }

            &-info {
                margin: 0 auto;
                max-width: 80%;

                @include mQ(550px) {
                    max-width: 100%;
                }

                a {
                    display: inline-block;
                    margin-top: 2rem;
                }
            }
        }

        &-trailer {
            max-width: 80%;
            margin: 0 auto;
            padding-top: 6rem;
            text-align: center;

            @include mQ(750px) {
                padding-top: 4rem;
                max-width: 100%;
            }

            p {
                margin: 0 auto;

                @include mQ(750px) {
                    max-width: 100%;
                }
            }

            p:first-of-type {
                margin-bottom: 1rem;
            }

            p a {
                color: $accent-color;
            }
        }
    }
}
</style>
